import classNames from 'classnames';
import React from 'react';
import styles from './ReadOnlyField.module.css';
import { Tooltip } from '@material-ui/core';
export var ReadOnlyField = function (props) {
    var _a, _b;
    var _c, _d;
    var nbsp = '\u00a0';
    var children = props.children === '' || React.Children.count(props.children) === 0 ? nbsp : props.children;
    var mode = (_c = props.mode) !== null && _c !== void 0 ? _c : 'field';
    var fieldClasses = classNames(styles.readOnlyField, (_a = {},
        _a[styles.fieldMode] = mode === 'field',
        _a[styles.noLabel] = props.label === null,
        _a[styles.noHelperText] = props.hideHelperText,
        _a[styles.multiLine] = props.multiLine,
        _a));
    var valueClasses = classNames(styles.value, (_b = {},
        _b[styles.fieldModeValue] = mode === 'field',
        _b[styles.alphanumeric] = props.alphanumeric,
        _b[styles.noWrapping] = props.noWrapping,
        _b));
    var value = props.noWrapping ? (React.createElement(Tooltip, { title: (_d = children === null || children === void 0 ? void 0 : children.toString()) !== null && _d !== void 0 ? _d : '', placement: props.tooltipPlacement },
        React.createElement("span", null, children))) : (children);
    return (React.createElement("div", { className: fieldClasses },
        props.label !== null && (React.createElement("div", { className: styles.label, style: { color: props.labelColour } }, props.label || nbsp)),
        React.createElement("div", { className: valueClasses, style: { color: props.valueColour } }, value)));
};
